import Vue from 'vue';
import VueRouter from 'vue-router';
//import DashBoard from '../views/DashBoardView.vue';
import Serie from '../views/series/SerieView.vue';
import Practice from '../views/practice/PracticeView.vue';
import Report from '../views/ReportView.vue';
import SectionEditor from '../views/events/races/SectionEditorView.vue';
import WaitList from '../views/WaitList.vue';
import Classes from '../views/Classes.vue';
import Brands from '../views/Brands.vue';
import Teams from '../views/Teams.vue';
import StartGrids from '../views/StartGrids.vue';
import StartGridsPrint from '../views/StartGridsPrint.vue';
import CloneEvents from '../views/CloneEvents.vue';
import CloneWaivers from '../views/CloneWaivers.vue';
import WaiverSigned from '../views/WaiverSigned.vue';
import MedicalInformation from '../views/MedicalInformation.vue';
import PromoterEventLink from '../views/PromoterEventLink.vue';
import RaceEdit from '../views/races/RaceEdit.vue';
import ImportEvent from '@/views/ImportEvent.vue';
import ImportRacesEvent from '@/views/ImportRaces.vue';

import NewParticipant from '../views/races/NewParticipant.vue';
import ParticipantScores from '../views/races/ParticipantScores.vue';
import DeleteClassScore from '../views/races/DeleteClassScore.vue';

import QuickScore from '../views/races/QuickScore.vue';
import Results from '../views/races/Results.vue';
import ScoreAnalysis from '../views/races/ScoreAnalysis.vue';
import AddDNFParticipants from '../views/races/AddDNFParticipants.vue';
import ClearAllScores from '../views/races/ClearAllScores.vue';
import ImportScoresFromRace from '../views/races/ImportScoresFromRace.vue';

import EventBrands from '../views/events/brands/EventBrands';
import ImportBrands from '../views/events/brands/ImportBrands';

import MyLaps from '../views/events/clone/MyLaps';
import SportTags from '../views/events/clone/SportTags';
import RaceTimer from '../views/events/clone/RaceTimer';
import Westhold from '../views/events/clone/Westhold';

import PhoneMonitor from '../views/races/PhoneMonitor.vue';
import EnduroSectionEditor from '../views/events/races/SectionEditorView.vue';
import EventDetails from '@/components/dashboard/eventDetails/EventDetails.vue';
import RaceDetails from '@/components/dashboard/raceDetails/RaceDetails.vue';
import PromoterDashboard from '@/components/dashboard/PromoterDashboard.vue';
import EventList from '@/components/dashboard/eventRaces/EventList.vue';
import CreateEvents from '@/components/dashboard/current/CreateEvents.vue';
import Registration from '@/views/events/registration/Registration.vue';
import CreateRegistrant from '@/views/events/registration/CreateRegistrant.vue';
import Pricing from '../views/Pricing.vue';
import ImportRegistrants from '@/views/events/registration/ImportRegistrants.vue';
import DeleteAllRegistrants from '../views/events/registration/DeleteAllRegistrants';
import ValidateAma from '../views/events/registration/ValidateAma';
import CreateRaces from '../views/races/CreateRaces.vue';

import EventClasses from '../views/events/classes/EventClasses.vue';
import LinkedClasses from '../views/events/classes/LinkedClasses';
import ImportClasses from '../views/events/classes/ImportClasses';
import FormClasses from '../views/events/classes/FormClasses.vue';
import classDivisions from '../views/events/Divisions.vue';

import Profile from '../views/Profile.vue';
import RaceList from '@/components/dashboard/eventRaces/RaceList.vue';
import RegistrationSetup from "@/components/dashboard/eventDetails/RegistrationSetup.vue";
import RaceClassesSetup from "@/views/races/configuration/RaceClassesSetup.vue";
import RaceParticipantsSetup from "@/views/races/configuration/RaceParticipantsSetup.vue";
import RaceScoringParameters from "@/views/races/configuration/RaceScoringParameters.vue";
import CreateBackupRace from "@/views/races/CreateBackupRace.vue";
import EventRaceList from "@/views/events/races/EventRaceList.vue";
import EventRaceImages from "@/views/events/races/EventRaceImages.vue";
import EventRaceAdvanceSettings from "@/views/events/races/EventRaceAdvanceSettings.vue";
import SerieDetailsView from "@/views/series/SerieDetailsView.vue";
import SerieResultsView from "@/views/series/SerieResultsView.vue";
import RegisteredSpectator from "@/views/events/registration/RegisteredSpectator.vue";
import RegisteredSpectatorGlobal from "@/views/RegisteredSpectatorGlobal.vue";
import WaiverCreate from "@/views/WaiverCreate.vue";
import Workers from "@/views/Workers.vue";
import WorkerCreate from "@/views/WorkerCreate.vue";
import WaiverSign from "@/views/WaiverSign.vue";
import WaiverSignForm from "@/views/WaiverSignForm.vue";
import PaymentManager from "@/views/PaymentManager.vue";

import Principal from "@/components/layouts/Principal.vue";
import ContainerSingle from "@/components/layouts/ContainerSingle.vue";
import PrintLayout from "@/components/layouts/PrintLayout.vue";
import axios from 'axios';

Vue.use(VueRouter);

const ifAuthenticated = async (to, from, next) => {
	const response = await axios.get(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/users/current`);
	if (response.data.message != 'not_found') {
		if (response.data.message.permissionName == "Promoter") {
			next();
			return;
		} else {
			window.location.href = process.env.VUE_APP_ROOT + response.data.message.linkPermission;
		}
	}

	window.location.href = process.env.VUE_APP_ROOT + '/login';
};

const ifPromoterOwnsRace = async (to, from, next) => {
	try {
		const raceId = to.params.id;
		if (!raceId) {
			next({ name: 'PromoterDashboard' });
			return;
		}

		const raceResponse = await axios.post(
			`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/promoter/race`,
			{ raceId, force: true }
		);
		
		if (!raceResponse.data || raceResponse.data.success != 1 || !raceResponse.data.message) {
			next({ name: 'PromoterDashboard' });
			return;
		}
		
		const eventId = raceResponse.data.message.eventId;
		if (!eventId) {
			next({ name: 'PromoterDashboard' });
			return;
		}

		const eventResponse = await axios.get(
			`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/promoter/eventDetails/getEvent/${eventId}`
		);
		const event = eventResponse.data &&
			eventResponse.data.message &&
			eventResponse.data.message.length > 0
			? eventResponse.data.message[0]
			: null;
		if (!event) {
			next({ name: 'PromoterDashboard' });
			return;
		}
		
		const userResponse = await axios.get(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/users/current`);
		const user = userResponse.data ? userResponse.data.message : null;
		const userPromoterId = user.id;
		const userRacePromoterId = event.userId;

		if (
			userPromoterId !== null &&
			userRacePromoterId !== null &&
			userPromoterId !== userRacePromoterId
		) {
			next({ name: 'PromoterDashboard' });
			return;
		}

		next();
	} catch (error) {
		next({ name: 'PromoterDashboard' });
	}
};

const routes = [
	{
		path: '/',
		redirect: { name: 'PromoterDashboard' },
	},
	{
		path: '/dashBoard',//Dashboard Layout
		component: Principal,
		children: [
			{
				path: '/',//Dashboard Layout
				component: PromoterDashboard,
				name: 'PromoterDashboard',
			},
			{
				path: 'eventDetails/:id',//Dashboard Layout
				component: EventDetails,
				name: 'eventDetails',
			},
			{
				path: 'raceDetails/:id',//Dashboard Layout
				component: RaceDetails,
				name: 'raceDetails',
			},
			{
				path: 'raceDetails/:id/race-editor',//Dashboard Layout
				name: 'raceEdit',
				component: RaceEdit,
			},
			{
				path: 'raceDetails/:id/new-participant',//Dashboard Layout
				name: 'NewParticipant',
				component: NewParticipant,
			},
			{
				path: 'raceDetails/:id/participants-scores',//Dashboard Layout
				name: 'ParticipantScores',
				component: ParticipantScores,
			},
			{
				path: 'raceDetails/:id/delete-class-scores',//Dashboard Layout
				name: 'DeleteClassScore',
				component: DeleteClassScore,
			},
			{
				path: 'raceDetails/:id/quick-scores',//Dashboard Layout
				name: 'QuickScore',
				component: QuickScore,
			},
			{
				path: 'raceDetails/:id/results',//Dashboard Layout
				name: 'Results',
				component: Results,
			},
			{
				path: 'raceDetails/:id/add-dnf-participants',//Dashboard Layout
				name: 'AddDNFParticipants',
				component: AddDNFParticipants,
			},
			{
				path: 'raceDetails/:id/clear-all-scores',//Dashboard Layout
				name: 'ClearAllScores',
				component: ClearAllScores,
			},
			{
				path: 'raceDetails/:id/import-scores-from-race',//Dashboard Layout
				name: 'ImportScoresFromRace',
				component: ImportScoresFromRace,
			},
			{
				path: '/reportsDashboard',//Dashboard Layout
				name: 'reportsDashboard',
				component: Report,
			},
			{
				path: '/eventList',//Dashboard Layout
				name: 'EventList',
				component: EventList,
			},
			{
				path: '/eventList/eventCreate',//Dashboard Layout
				name: 'EventCreate',
				component: CreateEvents,
			},
			{
				path: '/racesCreate/:id?',//Dashboard Layout
				name: 'RacesCreate',
				component: CreateRaces,
			},
			{
				path: '/seriesDashboard',//Dashboard Layout
				name: 'seriesDashboard',
				component: Serie,
			},
			{
				path: '/importEventDashboard',//Dashboard Layout
				name: 'ImportEventOld',
				component: ImportEvent,
			},
			{
				path: '/seriesDetails',//Dashboard Layout
				name: 'SerieDetails',
				component: SerieDetailsView,
			},
			{
				path: '/seriesResults',//Dashboard Layout
				name: 'SerieResults',
				component: SerieResultsView,
			},
			{
				path: 'eventDetails/:id/eventBrands',//Dashboard Layout
				name: 'EventBrands',
				component: EventBrands,
			},
			{
				path: 'eventDetails/:id/importBrands',//Dashboard Layout
				name: 'ImportBrands',
				component: ImportBrands,
			},
			{
				path: 'eventDetails/:id/registration',//Dashboard Layout
				name: 'Registration',
				component: Registration,
			},
			{
				path: 'eventDetails/:id/registerConfiguration', //Dashboard Layout
				name: 'RegistrationSetup',
				component: RegistrationSetup,
			},
			{
				path: 'eventDetails/:id/registeredSpectator', //Dashboard Layout
				name: 'RegisteredSpectator',
				component: RegisteredSpectator,
			},
			{
				path: 'eventDetails/:id/pricing',//Dashboard Layout
				name: 'Pricing',
				component: Pricing,
			},
			{
				path: '/eventDetails/:id/divisions',//Dashboard Layout
				name: 'classDivisions',
				component: classDivisions,
			},
			{
				path: 'eventDetails/:id/createregistrant',//Dashboard Layout
				name: 'CreateRegistrant',
				component: CreateRegistrant,
			},
			{
				path: 'eventDetails/:id/importregistrants',//Dashboard Layout
				name: 'ImportRegistrants',
				component: ImportRegistrants,
			},
			{
				path: 'eventDetails/:id/deletedallregistrant',//Dashboard Layout
				name: 'DeleteAllRegistrants',
				component: DeleteAllRegistrants,
			},
			{
				path: 'eventDetails/:id/validateama',//Dashboard Layout
				name: 'ValidateAma',
				component: ValidateAma,
			},
			{
				path: 'eventDetails/:id/waitList',//Dashboard Layout
				name: 'WaitList',
				component: WaitList,
			},
			{
				path: 'classes/:id',//No se
				name: 'Classes',
				component: Classes,
			},
			{
				path: 'brands/:id',//No se
				name: 'Brands',
				component: Brands,
			},
			{
				path: 'eventDetails/:id/teams',//Dashboard Layout
				name: 'Teams',
				component: Teams,
			},
			{
				path: 'eventDetails/:id/startGrids',//Dashboard Layout
				name: 'StartGrids',
				component: StartGrids,
			},
			{
				path: 'cloneEvents',//Dashboard Layout
				name: 'CloneEvents',
				component: CloneEvents,
			},
			{
				path: 'eventDetails/:id/myLaps',//Dashboard Layout
				name: 'MyLaps',
				component: MyLaps,
			},
			{
				path: 'eventDetails/:id/sportTags',//Dashboard Layout
				name: 'SportTags',
				component: SportTags,
			},
			{
				path: 'eventDetails/:id/raceTimer',//Dashboard Layout
				name: 'RaceTimer',
				component: RaceTimer,
			},
			{
				path: 'eventDetails/:id/westhold',//Dashboard Layout
				name: 'Westhold',
				component: Westhold,
			},
			{
				path: 'eventDetails/:id/raceList',//Dashboard Layout
				name: 'EventRaceList',
				component: EventRaceList
			},
			{
				path: 'eventDetails/:id/raceImages',//Dashboard Layout
				name: 'EventRaceImages',
				component: EventRaceImages
			},
			{
				path: 'eventDetails/:id/raceAdvanceSettings',//Dashboard Layout
				name: 'EventRaceAdvanceSettings',
				component: EventRaceAdvanceSettings
			},
			{
				path: 'eventDetails/:id/eventClasses',//Dashboard Layout
				name: 'EventClasses',
				component: EventClasses,
			},
			{
				path: 'eventDetails/:id/linkedClasses',//Dashboard Layout
				name: 'LinkedClasses',
				component: LinkedClasses,
			},
			{
				path: 'eventDetails/:id/importClasses',//Dashboard Layout
				name: 'ImportClasses',
				component: ImportClasses,
			},
			{
				path: 'eventDetails/:id/eventClasses/create',//Dashboard Layout
				name: 'CreateClasses',
				component: FormClasses,
			},
			{
				path: '/eventDetails/:id/eventClasses/edit/:idClass',//No se
				name: 'EditClasses',
				component: FormClasses,
			},
			{
				path: '/raceList',//Dashboard Layout
				name: 'RaceList',
				component: RaceList,
			},
			{
				path: '/profile',//Dashboard Layout
				name: 'Profile',
				component: Profile,
			},
			{
				path: 'raceDetails/:id/phoneMonitor',//Dashboard Layout
				name: 'PhoneMonitor',
				component: PhoneMonitor,
			},
			{
				path: 'raceDetails/:id/section-editor',//Dashboard Layout
				name: 'SectionEditor',
				component: SectionEditor
			},
			{
				path: 'raceDetails/:id/race-classes-setup',//Dashboard Layout
				name: 'RaceClassesSetup',
				component: RaceClassesSetup
			},
			{
				path: 'raceDetails/:id/race-scoring-parameters',//Dashboard Layout
				name: 'RaceScoringParameters',
				component: RaceScoringParameters
			},
			{
				path: 'raceDetails/:id/race-participants-setup',//Dashboard Layout
				name: 'RaceParticipantsSetup',
				component: RaceParticipantsSetup
			}
		],
		beforeEnter: ifAuthenticated,
	},
	{
		path: '/general',
		component: ContainerSingle,
		children: [
			{
				path: '/medicalInformation',//Simple Layout
				name: 'MedicalInformation',
				component: MedicalInformation,
			},
			{
				path: '/importRaces',//Simple Layout
				name: 'ImportRaces',
				component: ImportRacesEvent,
			},
			{
				path: '/series',//Simple Layout
				name: 'Serie',
				component: Serie,
			},
			{
				path: '/eventDetails/:id/practice',//Dashboard Layout
				name: 'practice',
				component: Practice,
			},
			{
				path: '/reports',//Simple Layout
				name: 'Report',
				component: Report,
			},
			{
				path: '/promoterEventLink',//Simple Layout
				name: 'PromoterEventLink',
				component: PromoterEventLink,
			},
			{
				path: '/waivers/cloneWaivers',//Simple Layout
				name: 'CloneWaiversOld',
				component: CloneWaivers,
			},
			{
				path: '/waivers/signed',//Simple Layout
				name: 'Signed',
				component: WaiverSigned,
			},
			{
				path: '/waivers/sign',//Simple Layout
				name: 'WaiverSign',
				component: WaiverSign,
			},
			{
				path: '/waivers/create',//Simple Layout
				name: 'WaiverCreate',
				component: WaiverCreate,
			},
			{
				path: '/waivers/edit/:id',//Simple Layout
				name: 'WaiverEdit',
				component: WaiverCreate,
			},
			{
				path: '/importEvent',//Simple Layout
				name: 'ImportEvent',
				component: ImportEvent,
			},
			{
				path: '/waivers/sign/form',
				name: 'WaiverSignForm',
				component: WaiverSignForm,
			},
			{
				path: '/events/:id/registeredSpectators',
				name: 'RegisteredSpectatorGlobal',
				component: RegisteredSpectatorGlobal,
			},
			{
				path: '/enduroSectionEditor/raceId/:id',
				name: 'EnduroSectionEditor',
				component: EnduroSectionEditor,
			},
			{
				path: '/events/races/section-editor/:id',
				name: 'SectionEditorOld',
				component: SectionEditor,
			},
			{
				path: '/events/event-details/pricing/:id',
				name: 'PricingOld',
				component: Pricing,
			},
			{
				path: '/events/event-details/practice/:id',
				name: 'PracticeOld',
				component: Practice,
			},
			{
				path: '/events/event-details/divisions/:id',
				name: 'DivisionsOld',
				component: classDivisions,
			},
			{
				path: '/events/races/raceDetails/results/:id',
				name: 'ResultsOld',
				component: Results,
			},
			{
				path: '/events/races/raceDetails/raceAnalysis/:id',
				name: 'ScoreAnalysis',
				component: ScoreAnalysis,
				beforeEnter: ifPromoterOwnsRace,
			},
			{
				path: '/events/races/raceDetails/CreateBackupRace/:id?',
				name: 'CreateBackupRace',
				component: CreateBackupRace,
			},
			{
				path: '/events/races/raceDetails/edit-scores/:id',
				name: 'ParticipantScoresOld',
				component: ParticipantScores,
			},
			{
				path: '/events/cloneEvents',
				name: 'CloneEventsOld',
				component: CloneEvents,
			},
			{
				path: '/workers',//Dashboard Layout
				name: 'Workers',
				component: Workers,
			},
			{
				path: '/workers/create',//Dashboard Layout
				name: 'WorkerCreate',
				component: WorkerCreate,
			},
			{
				path: '/paymentManager',
				name: 'PaymentManager',
				component: PaymentManager,
			}
		],
		beforeEnter: ifAuthenticated,
	},
	{
		path: '/',
		component: PrintLayout,
		children: [
			{
				path: '/eventDetails/:id/startGrids/print',
				name: 'StartGridsPrint',
				component: StartGridsPrint,
			},
		]
	}
];

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
});

export default router;
